import React, { useEffect } from "react";
import { SubscriptionOverviewChartBlock } from "../../../SubscriptionBackendPortal/overview/subscription-overview";
import { TrialPerformance } from "../../../SubscriptionBackendPortal/overview/info-tables";
import useGetSBAccountTile from "../../../../hooks/get-sb-account-tile.hook";
import useDateDefineds from "../../../../hooks/date-defineds.hook";
import { DATE_FORMAT } from "../../../../constants/app.constants";
import moment from "moment";
import MembersPageLoader from "../../../settingsV2/members/MembersPageLoader";

const DistributorOverview = ({ distributorId }) => {
  const isDistributor = true;
  const defineds = useDateDefineds();
  const { data: pageData, isLoading: pageLoading, fetchData } = useGetSBAccountTile();
  const showPageLoader = pageLoading && !pageData;

  useEffect(() => {
    fetchData({
      fromDate: moment(defineds.startOfLastTwelveMonth).format(DATE_FORMAT),
      endDate: moment(defineds.endOfToday).format(DATE_FORMAT),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const statsConfig = [
    { title: "Active", value: pageData?.stats?.active ?? 0 },
    { title: "Suspended", value: pageData?.stats?.suspended ?? 0 },
    { title: "Active trials", value: pageData?.stats?.active_trials ?? 0 },
    { title: "Expired Trial", value: pageData?.stats?.expired_trial ?? 0 },
    { title: "Paid accounts", value: pageData?.stats?.paid ?? 0 },
    { title: "Overall Accounts", value: pageData?.stats?.overall ?? 0 },
  ];

  if (showPageLoader) {
    return <MembersPageLoader />;
  }

  return (
    <div style={{ padding: "24px 40px" }}>
      <div style={{ marginBottom: '24px' }}>
        <SubscriptionOverviewChartBlock 
          activeMSPAccounts={pageData?.activeMSPAccounts}
          statsConfig={statsConfig}
          isDistributor={isDistributor}
        />
        {isDistributor && (
          <TrialPerformance isDistributor={isDistributor} />
        )}
      </div>
    </div>
  );
};

export default DistributorOverview;
